import {
  HiOutlineDocumentReport,
  HiOutlineClipboardList,
} from 'react-icons/hi';
import { FiShoppingCart, FiRefreshCcw, FiTruck, FiPackage, FiEdit3 } from 'react-icons/fi';
import { FaRegShareFromSquare } from 'react-icons/fa6';
import { TbReportSearch } from 'react-icons/tb';
import { MdOutlineAutoGraph } from 'react-icons/md';

const FILTER_LIBRARY = {
  dateRange: [
    { id: 'fromDate', type: 'date', label: 'From Date' },
    { id: 'toDate', type: 'date', label: 'To Date' },
  ],
  billStatus: [
    {
      id: 'billStatus',
      type: 'select',
      label: 'Bill Status',
      options: [
        { label: 'All', value: 'all' },
        { label: 'Open', value: 'open' },
        { label: 'Closed', value: 'closed' },
      ],
    },
  ],
  patient: [
    {
      id: 'patient',
      type: 'search',
      label: 'Patient',
      placeholder: 'Search patient name or UHID',
    },
  ],
  doctor: [
    {
      id: 'doctor',
      type: 'select',
      label: 'Doctor',
      options: [
        { label: 'All Doctors', value: 'all' },
        { label: 'Dr. Kavya Rao', value: 'kavya-rao' },
        { label: 'Dr. Ramesh Pillai', value: 'ramesh-pillai' },
        { label: 'Dr. Asha Kumar', value: 'asha-kumar' },
      ],
    },
  ],
  schedule: [
    {
      id: 'schedule',
      type: 'select',
      label: 'Schedule',
      options: [
        { label: 'All Schedules', value: 'all' },
        { label: 'Morning', value: 'morning' },
        { label: 'Afternoon', value: 'afternoon' },
        { label: 'Evening', value: 'evening' },
      ],
    },
  ],
  hsn: [
    {
      id: 'hsn',
      type: 'select',
      label: 'HSN Code',
      options: [
        { label: 'All Codes', value: 'all' },
        { label: '3004', value: '3004' },
        { label: '3003', value: '3003' },
        { label: '1902', value: '1902' },
      ],
    },
  ],
  item: [
    {
      id: 'item',
      type: 'search',
      label: 'Item',
      placeholder: 'Search item, SKU, or barcode',
    },
  ],
  supplier: [
    {
      id: 'supplier',
      type: 'select',
      label: 'Supplier',
      options: [
        { label: 'All Suppliers', value: 'all' },
        { label: 'Fluxion Pharma', value: 'fluxion' },
        { label: 'Sunrise Distributors', value: 'sunrise' },
        { label: 'Wellness Hub', value: 'wellness' },
      ],
    },
  ],
  user: [
    {
      id: 'user',
      type: 'select',
      label: 'User',
      options: [
        { label: 'All Users', value: 'all' },
        { label: 'Swathi Menon', value: 'swathi-menon' },
        { label: 'Rahul Sharma', value: 'rahul-sharma' },
        { label: 'Deepa Nair', value: 'deepa-nair' },
      ],
    },
  ],
  department: [
    {
      id: 'department',
      type: 'select',
      label: 'Department',
      options: [
        { label: 'All Departments', value: 'all' },
        { label: 'Emergency', value: 'emergency' },
        { label: 'Cardiology', value: 'cardiology' },
        { label: 'Paediatrics', value: 'paediatrics' },
      ],
    },
  ],
  gst: [
    {
      id: 'gst',
      type: 'select',
      label: 'GST %',
      options: [
        { label: 'All Slabs', value: 'all' },
        { label: '0%', value: '0' },
        { label: '5%', value: '5' },
        { label: '12%', value: '12' },
        { label: '18%', value: '18' },
      ],
    },
  ],
  batch: [
    {
      id: 'batch',
      type: 'search',
      label: 'Batch No.',
      placeholder: 'Search batch number',
    },
  ],
  chemical: [
    {
      id: 'chemical',
      type: 'select',
      label: 'Chemical',
      options: [
        { label: 'All Chemicals', value: 'all' },
        { label: 'Paracetamol', value: 'paracetamol' },
        { label: 'Amoxicillin', value: 'amoxicillin' },
        { label: 'Cetirizine', value: 'cetirizine' },
      ],
    },
  ],
  company: [
    {
      id: 'company',
      type: 'select',
      label: 'Company',
      options: [
        { label: 'All Companies', value: 'all' },
        { label: 'Fluxion Pharma', value: 'fluxion' },
        { label: 'Alpha Labs', value: 'alpha' },
        { label: 'BioLife', value: 'biolife' },
      ],
    },
  ],
};

const buildFilters = (keys = []) =>
  keys.flatMap((key) => FILTER_LIBRARY[key] ?? []).map((filter) => ({ ...filter }));

const SAMPLE_TABLES = {
  billWise: {
    columns: [
      { key: 'billNo', label: 'Bill No.' },
      { key: 'billDate', label: 'Bill Date' },
      { key: 'customer', label: 'Customer' },
      { key: 'totalItems', label: 'Total Items' },
      { key: 'taxAmount', label: 'Tax Amount' },
      { key: 'netAmount', label: 'Net Amount' },
    ],
    rows: [
      {
        billNo: 'INV-10021',
        billDate: '2025-11-02',
        customer: 'Medicare Clinic',
        totalItems: 12,
        taxAmount: '₹540.00',
        netAmount: '₹6,120.00',
      },
      {
        billNo: 'INV-10022',
        billDate: '2025-11-02',
        customer: 'City Diagnostics',
        totalItems: 8,
        taxAmount: '₹320.00',
        netAmount: '₹3,780.00',
      },
      {
        billNo: 'INV-10023',
        billDate: '2025-11-03',
        customer: 'Walk-in',
        totalItems: 6,
        taxAmount: '₹180.00',
        netAmount: '₹1,890.00',
      },
    ],
  },
  itemWise: {
    columns: [
      { key: 'itemName', label: 'Item' },
      { key: 'batch', label: 'Batch No.' },
      { key: 'qty', label: 'Qty' },
      { key: 'mrp', label: 'MRP' },
      { key: 'tax', label: 'Tax' },
      { key: 'sales', label: 'Sales Value' },
    ],
    rows: [
      {
        itemName: 'Paracetamol 650mg',
        batch: 'PC650-0925A',
        qty: 180,
        mrp: '₹23.00',
        tax: '₹210.60',
        sales: '₹4,248.00',
      },
      {
        itemName: 'Amoxicillin 500mg',
        batch: 'AMX500-1025B',
        qty: 96,
        mrp: '₹42.00',
        tax: '₹201.60',
        sales: '₹4,032.00',
      },
      {
        itemName: 'Vitamin C Chew Tabs',
        batch: 'VITC-0825D',
        qty: 150,
        mrp: '₹18.00',
        tax: '₹121.50',
        sales: '₹2,295.00',
      },
    ],
  },
  patientWise: {
    columns: [
      { key: 'patient', label: 'Patient' },
      { key: 'uhid', label: 'UHID' },
      { key: 'totalBills', label: 'Bills' },
      { key: 'totalItems', label: 'Items' },
      { key: 'grossValue', label: 'Gross Value' },
      { key: 'netValue', label: 'Net Value' },
    ],
    rows: [
      {
        patient: 'Rahul Sharma',
        uhid: 'UH1023',
        totalBills: 3,
        totalItems: 18,
        grossValue: '₹2,340.00',
        netValue: '₹2,210.00',
      },
      {
        patient: 'Priya Nair',
        uhid: 'UH1120',
        totalBills: 2,
        totalItems: 11,
        grossValue: '₹1,460.00',
        netValue: '₹1,390.00',
      },
    ],
  },
  doctorWise: {
    columns: [
      { key: 'doctor', label: 'Doctor' },
      { key: 'department', label: 'Department' },
      { key: 'prescriptions', label: 'Prescriptions' },
      { key: 'items', label: 'Items' },
      { key: 'revenue', label: 'Revenue' },
    ],
    rows: [
      {
        doctor: 'Dr. Kavya Rao',
        department: 'General Medicine',
        prescriptions: 26,
        items: 142,
        revenue: '₹68,420.00',
      },
      {
        doctor: 'Dr. Ramesh Pillai',
        department: 'Cardiology',
        prescriptions: 11,
        items: 63,
        revenue: '₹38,750.00',
      },
      {
        doctor: 'Dr. Asha Kumar',
        department: 'Paediatrics',
        prescriptions: 18,
        items: 94,
        revenue: '₹26,940.00',
      },
    ],
  },
  scheduleWise: {
    columns: [
      { key: 'schedule', label: 'Schedule' },
      { key: 'bills', label: 'Bills' },
      { key: 'items', label: 'Items' },
      { key: 'gross', label: 'Gross' },
      { key: 'net', label: 'Net' },
    ],
    rows: [
      {
        schedule: 'Morning',
        bills: 42,
        items: 214,
        gross: '₹96,540.00',
        net: '₹92,380.00',
      },
      {
        schedule: 'Afternoon',
        bills: 28,
        items: 168,
        gross: '₹64,820.00',
        net: '₹62,410.00',
      },
      {
        schedule: 'Evening',
        bills: 35,
        items: 194,
        gross: '₹71,330.00',
        net: '₹69,980.00',
      },
    ],
  },
  hsnWise: {
    columns: [
      { key: 'hsn', label: 'HSN Code' },
      { key: 'description', label: 'Description' },
      { key: 'items', label: 'Items' },
      { key: 'qty', label: 'Qty' },
      { key: 'taxable', label: 'Taxable Value' },
      { key: 'tax', label: 'GST Amount' },
    ],
    rows: [
      {
        hsn: '3004',
        description: 'Medicaments for therapeutic uses',
        items: 18,
        qty: 562,
        taxable: '₹1,42,560.00',
        tax: '₹12,568.80',
      },
      {
        hsn: '3003',
        description: 'Medicaments excluding hormones',
        items: 11,
        qty: 310,
        taxable: '₹72,430.00',
        tax: '₹6,518.70',
      },
    ],
  },
  billItemList: {
    columns: [
      { key: 'billNo', label: 'Bill No.' },
      { key: 'billDate', label: 'Bill Date' },
      { key: 'itemName', label: 'Item' },
      { key: 'qty', label: 'Qty' },
      { key: 'rate', label: 'Rate' },
      { key: 'amount', label: 'Amount' },
    ],
    rows: [
      {
        billNo: 'INV-10021',
        billDate: '2025-11-02',
        itemName: 'Paracetamol 650mg',
        qty: 10,
        rate: '₹21.00',
        amount: '₹210.00',
      },
      {
        billNo: 'INV-10021',
        billDate: '2025-11-02',
        itemName: 'Vitamin C Chew Tabs',
        qty: 6,
        rate: '₹16.50',
        amount: '₹99.00',
      },
      {
        billNo: 'INV-10022',
        billDate: '2025-11-02',
        itemName: 'Amoxicillin 500mg',
        qty: 4,
        rate: '₹39.00',
        amount: '₹156.00',
      },
    ],
  },
  billProfit: {
    columns: [
      { key: 'billNo', label: 'Bill No.' },
      { key: 'billDate', label: 'Bill Date' },
      { key: 'costValue', label: 'Cost Value' },
      { key: 'salesValue', label: 'Sales Value' },
      { key: 'grossProfit', label: 'Gross Profit' },
      { key: 'margin', label: 'Margin %' },
    ],
    rows: [
      {
        billNo: 'INV-10018',
        billDate: '2025-11-01',
        costValue: '₹4,865.00',
        salesValue: '₹5,940.00',
        grossProfit: '₹1,075.00',
        margin: '22.1%',
      },
      {
        billNo: 'INV-10019',
        billDate: '2025-11-01',
        costValue: '₹2,130.00',
        salesValue: '₹2,640.00',
        grossProfit: '₹510.00',
        margin: '23.9%',
      },
      {
        billNo: 'INV-10020',
        billDate: '2025-11-02',
        costValue: '₹3,780.00',
        salesValue: '₹4,425.00',
        grossProfit: '₹645.00',
        margin: '17.1%',
      },
    ],
  },
  billItemProfit: {
    columns: [
      { key: 'billNo', label: 'Bill No.' },
      { key: 'itemName', label: 'Item' },
      { key: 'qty', label: 'Qty' },
      { key: 'cost', label: 'Cost' },
      { key: 'sales', label: 'Sales' },
      { key: 'profit', label: 'Profit' },
    ],
    rows: [
      {
        billNo: 'INV-10020',
        itemName: 'Amoxicillin 500mg',
        qty: 6,
        cost: '₹198.00',
        sales: '₹246.00',
        profit: '₹48.00',
      },
      {
        billNo: 'INV-10020',
        itemName: 'Vitamin C Chew Tabs',
        qty: 8,
        cost: '₹96.00',
        sales: '₹132.00',
        profit: '₹36.00',
      },
      {
        billNo: 'INV-10021',
        itemName: 'Paracetamol 650mg',
        qty: 12,
        cost: '₹210.00',
        sales: '₹252.00',
        profit: '₹42.00',
      },
    ],
  },
  gstWise: {
    columns: [
      { key: 'gst', label: 'GST %' },
      { key: 'taxable', label: 'Taxable Value' },
      { key: 'tax', label: 'GST Amount' },
      { key: 'bills', label: 'Bills' },
      { key: 'items', label: 'Items' },
    ],
    rows: [
      { gst: '0%', taxable: '₹18,540.00', tax: '₹0.00', bills: 12, items: 96 },
      { gst: '5%', taxable: '₹34,620.00', tax: '₹1,731.00', bills: 21, items: 178 },
      { gst: '12%', taxable: '₹42,980.00', tax: '₹5,157.60', bills: 24, items: 163 },
      { gst: '18%', taxable: '₹51,260.00', tax: '₹9,226.80', bills: 32, items: 204 },
    ],
  },
  supplierWise: {
    columns: [
      { key: 'supplier', label: 'Supplier' },
      { key: 'invoices', label: 'Invoices' },
      { key: 'items', label: 'Items' },
      { key: 'gross', label: 'Gross Purchase' },
      { key: 'discount', label: 'Discount' },
      { key: 'net', label: 'Net Purchase' },
    ],
    rows: [
      {
        supplier: 'Fluxion Pharma',
        invoices: 11,
        items: 146,
        gross: '₹92,430.00',
        discount: '₹4,320.00',
        net: '₹88,110.00',
      },
      {
        supplier: 'Sunrise Distributors',
        invoices: 8,
        items: 104,
        gross: '₹61,980.00',
        discount: '₹2,870.00',
        net: '₹59,110.00',
      },
      {
        supplier: 'Wellness Hub',
        invoices: 5,
        items: 72,
        gross: '₹34,260.00',
        discount: '₹1,120.00',
        net: '₹33,140.00',
      },
    ],
  },
  customerWise: {
    columns: [
      { key: 'customer', label: 'Customer' },
      { key: 'bills', label: 'Bills' },
      { key: 'items', label: 'Items' },
      { key: 'returns', label: 'Returns' },
      { key: 'net', label: 'Net Return Value' },
    ],
    rows: [
      {
        customer: 'Medicare Clinic',
        bills: 5,
        items: 26,
        returns: '₹2,140.00',
        net: '₹1,980.00',
      },
      {
        customer: 'City Diagnostics',
        bills: 3,
        items: 19,
        returns: '₹1,460.00',
        net: '₹1,390.00',
      },
    ],
  },
  departmentWise: {
    columns: [
      { key: 'department', label: 'Department' },
      { key: 'transferOut', label: 'Transfer Out' },
      { key: 'transferIn', label: 'Transfer In' },
      { key: 'items', label: 'Items' },
      { key: 'netMovement', label: 'Net Movement' },
    ],
    rows: [
      {
        department: 'Emergency',
        transferOut: '₹12,430.00',
        transferIn: '₹9,260.00',
        items: 84,
        netMovement: '₹3,170.00',
      },
      {
        department: 'ICU',
        transferOut: '₹7,930.00',
        transferIn: '₹11,540.00',
        items: 63,
        netMovement: '-₹3,610.00',
      },
      {
        department: 'Pharmacy Main',
        transferOut: '₹18,640.00',
        transferIn: '₹22,430.00',
        items: 148,
        netMovement: '-₹3,790.00',
      },
    ],
  },
  userWise: {
    columns: [
      { key: 'user', label: 'User' },
      { key: 'transactions', label: 'Transactions' },
      { key: 'items', label: 'Items' },
      { key: 'approvals', label: 'Approvals' },
      { key: 'variance', label: 'Variance' },
    ],
    rows: [
      {
        user: 'Swathi Menon',
        transactions: 41,
        items: 276,
        approvals: 38,
        variance: '0.4%',
      },
      {
        user: 'Rahul Sharma',
        transactions: 32,
        items: 214,
        approvals: 30,
        variance: '0.2%',
      },
      {
        user: 'Deepa Nair',
        transactions: 24,
        items: 188,
        approvals: 24,
        variance: '0%',
      },
    ],
  },
  batchWise: {
    columns: [
      { key: 'batch', label: 'Batch No.' },
      { key: 'itemName', label: 'Item' },
      { key: 'expiry', label: 'Expiry' },
      { key: 'qty', label: 'Qty' },
      { key: 'value', label: 'Stock Value' },
    ],
    rows: [
      {
        batch: 'PC650-0925A',
        itemName: 'Paracetamol 650mg',
        expiry: '2026-09',
        qty: 120,
        value: '₹2,520.00',
      },
      {
        batch: 'AMX500-1025B',
        itemName: 'Amoxicillin 500mg',
        expiry: '2026-10',
        qty: 84,
        value: '₹3,528.00',
      },
      {
        batch: 'VITC-0825D',
        itemName: 'Vitamin C Chew Tabs',
        expiry: '2027-08',
        qty: 96,
        value: '₹1,536.00',
      },
    ],
  },
  chemicalWise: {
    columns: [
      { key: 'chemical', label: 'Chemical' },
      { key: 'items', label: 'Items' },
      { key: 'stockQty', label: 'Stock Qty' },
      { key: 'stockValue', label: 'Stock Value' },
      { key: 'consumption', label: 'Consumption (30d)' },
    ],
    rows: [
      {
        chemical: 'Paracetamol',
        items: 4,
        stockQty: 860,
        stockValue: '₹12,630.00',
        consumption: '640',
      },
      {
        chemical: 'Cetirizine',
        items: 3,
        stockQty: 560,
        stockValue: '₹7,820.00',
        consumption: '410',
      },
      {
        chemical: 'Amoxicillin',
        items: 5,
        stockQty: 430,
        stockValue: '₹9,340.00',
        consumption: '310',
      },
    ],
  },
  companyWise: {
    columns: [
      { key: 'company', label: 'Company' },
      { key: 'items', label: 'Items' },
      { key: 'stockQty', label: 'Stock Qty' },
      { key: 'stockValue', label: 'Stock Value' },
      { key: 'ageing', label: 'Avg. Ageing' },
    ],
    rows: [
      {
        company: 'Fluxion Pharma',
        items: 28,
        stockQty: 1_240,
        stockValue: '₹28,430.00',
        ageing: '32 days',
      },
      {
        company: 'Alpha Labs',
        items: 21,
        stockQty: 980,
        stockValue: '₹24,180.00',
        ageing: '38 days',
      },
      {
        company: 'BioLife',
        items: 16,
        stockQty: 760,
        stockValue: '₹17,960.00',
        ageing: '29 days',
      },
    ],
  },
  stockOverview: {
    columns: [
      { key: 'itemName', label: 'Item' },
      { key: 'batch', label: 'Batch' },
      { key: 'availableQty', label: 'Available Qty' },
      { key: 'reservedQty', label: 'Reserved Qty' },
      { key: 'stockValue', label: 'Stock Value' },
    ],
    rows: [
      {
        itemName: 'Paracetamol 650mg',
        batch: 'PC650-0925A',
        availableQty: 180,
        reservedQty: 24,
        stockValue: '₹3,780.00',
      },
      {
        itemName: 'Amoxicillin 500mg',
        batch: 'AMX500-1025B',
        availableQty: 96,
        reservedQty: 12,
        stockValue: '₹3,024.00',
      },
      {
        itemName: 'Vitamin C Chew Tabs',
        batch: 'VITC-0825D',
        availableQty: 150,
        reservedQty: 18,
        stockValue: '₹2,700.00',
      },
    ],
  },
  consumption: {
    columns: [
      { key: 'itemName', label: 'Item' },
      { key: 'avgDaily', label: 'Avg. Daily Usage' },
      { key: 'lastMonth', label: 'Last 30 Days' },
      { key: 'stockOnHand', label: 'Stock On Hand' },
      { key: 'daysCover', label: 'Days of Cover' },
    ],
    rows: [
      {
        itemName: 'Paracetamol 650mg',
        avgDaily: 28,
        lastMonth: 840,
        stockOnHand: 620,
        daysCover: 22,
      },
      {
        itemName: 'Cough Syrup 100ml',
        avgDaily: 14,
        lastMonth: 392,
        stockOnHand: 280,
        daysCover: 20,
      },
      {
        itemName: 'Aspirin 75mg',
        avgDaily: 9,
        lastMonth: 270,
        stockOnHand: 190,
        daysCover: 21,
      },
    ],
  },
};

const SAMPLE_METRICS = {
  billWise: [
    { label: 'Total Bills', value: '105', trend: '+8.2% vs last period' },
    { label: 'Avg. Bill Value', value: '₹2,870', trend: '+3.4%' },
    { label: 'Gross Sales', value: '₹3,01,420', trend: '+6.9%' },
  ],
  itemWise: [
    { label: 'Unique Items', value: '148', trend: '+5.3%' },
    { label: 'Top Seller', value: 'Paracetamol 650mg', trend: '18% of volume' },
    { label: 'Stock-outs', value: '0', trend: 'No stock-outs recorded' },
  ],
  patientWise: [
    { label: 'Active Patients', value: '62', trend: '+4 since last week' },
    { label: 'Repeat Visits', value: '38', trend: '61% repeat ratio' },
    { label: 'High Value Patient', value: 'Rahul Sharma', trend: '₹2,210 net' },
  ],
  doctorWise: [
    { label: 'Prescribing Doctors', value: '12', trend: '+1 new doctor' },
    { label: 'Avg. Rx Value', value: '₹5,420', trend: '+2.1%' },
    { label: 'Top Department', value: 'General Medicine', trend: '46% of orders' },
  ],
  scheduleWise: [
    { label: 'Busiest Slot', value: 'Morning', trend: '42 bills' },
    { label: 'Avg. Wait Time', value: '6.5 mins', trend: '-0.8 mins' },
    { label: 'Staff On Duty', value: '5', trend: 'All shifts staffed' },
  ],
  hsnWise: [
    { label: 'HSN Codes', value: '18', trend: 'Stable mix' },
    { label: 'GST Liability', value: '₹24,087', trend: '+4.2%' },
    { label: 'Nil Rated', value: '₹18,540', trend: '12% of turnover' },
  ],
  billItemList: [
    { label: 'Line Items', value: '328', trend: '+6.7%' },
    { label: 'Items / Bill', value: '4.3', trend: '+0.2 items' },
    { label: 'Discount Impact', value: '₹2,180', trend: 'Uniform discounting' },
  ],
  billProfit: [
    { label: 'Gross Margin', value: '19.6%', trend: '+0.8%' },
    { label: 'High Profit Bill', value: 'INV-10018', trend: '₹1,075' },
    { label: 'Low Margin Alerts', value: '3 bills', trend: 'Review required' },
  ],
  billItemProfit: [
    { label: 'Profitable Items', value: '42', trend: '+5 identified' },
    { label: 'Avg. Profit / Item', value: '₹32', trend: '+₹3.40' },
    { label: 'Loss Making Items', value: '0', trend: 'Healthy mix' },
  ],
  gstWise: [
    { label: 'Total GST', value: '₹16,155', trend: '+6.9%' },
    { label: 'Major Slab', value: '18%', trend: '51% of liability' },
    { label: 'Zero Rated', value: '12 bills', trend: 'Monitor compliance' },
  ],
  supplierWise: [
    { label: 'Active Suppliers', value: '9', trend: 'No new additions' },
    { label: 'Top Supplier', value: 'Fluxion Pharma', trend: '₹88,110 net' },
    { label: 'Avg. Turnaround', value: '2.4 days', trend: '-0.4 days' },
  ],
  customerWise: [
    { label: 'Return %', value: '1.8%', trend: '-0.3%' },
    { label: 'Repeat Customers', value: '74%', trend: 'Healthy loyalty' },
    { label: 'Most Returns', value: 'Medicare Clinic', trend: '₹1,980 net' },
  ],
  departmentWise: [
    { label: 'Net Transfers', value: '₹18,460', trend: '+2.1%' },
    { label: 'Peak Department', value: 'Pharmacy Main', trend: 'High inbound' },
    { label: 'Pending Approvals', value: '2', trend: 'Review required' },
  ],
  userWise: [
    { label: 'Active Users', value: '7', trend: '3 on this shift' },
    { label: 'Accuracy', value: '99.4%', trend: 'Excellent controls' },
    { label: 'Approvals Pending', value: '1', trend: 'Due before EOD' },
  ],
  batchWise: [
    { label: 'Expiring (90d)', value: '4 batches', trend: 'Need clearance' },
    { label: 'Value at Risk', value: '₹8,420', trend: 'Stock rotation needed' },
    { label: 'Avg. Ageing', value: '114 days', trend: 'Stable' },
  ],
  chemicalWise: [
    { label: 'Unique Chemicals', value: '28', trend: 'Balanced portfolio' },
    { label: 'Consumption (30d)', value: '1,360 units', trend: '+4.6%' },
    { label: 'Critical Stock', value: 'Cetirizine', trend: 'Review reorder' },
  ],
  companyWise: [
    { label: 'Top Company', value: 'Fluxion Pharma', trend: '₹28,430 value' },
    { label: 'Slow Movers', value: '2 companies', trend: 'Ageing > 45d' },
    { label: 'Reorder Required', value: 'Alpha Labs', trend: '4 SKUs below min' },
  ],
  stockOverview: [
    { label: 'Total Stock Value', value: '₹1,42,870', trend: '+2.3%' },
    { label: 'Items Below MOQ', value: '6', trend: 'Action required' },
    { label: 'Reserved Qty', value: '54 units', trend: 'Planned orders' },
  ],
  consumption: [
    { label: 'Avg. Daily Use', value: '112 units', trend: '+6 units' },
    { label: 'Days of Cover', value: '21 days', trend: '-1.5 days' },
    { label: 'Reorder Alerts', value: '4 items', trend: 'Trigger soon' },
  ],
};

const createReport = ({
  id,
  name,
  description,
  filters = [],
  tableKey,
  metricsKey,
  permissionModule = null,
  permissionAction = 'Create',
}) => ({
  id,
  name,
  description,
  filters: buildFilters(['dateRange', ...filters]),
  table: SAMPLE_TABLES[tableKey],
  metrics: SAMPLE_METRICS[metricsKey || tableKey],
  permissionModule,
  permissionAction,
});

/** Same rule as LeftMenu: Admin bypasses; otherwise module must grant permissionAction (default Create). */
export function userCanAccessReport(userInfo, permissions, report) {
  if (!report) return false;
  if (userInfo?.Designation === 'Admin') return true;
  const mod = report.permissionModule;
  const action = report.permissionAction || 'Create';
  if (!mod) return true;
  return Boolean(permissions[mod]?.[action]);
}

/** Tab path is `${category.id}${report.id}` (see reportInlineRoutes). */
export function findReportByInlinePath(inlinePath) {
  if (!inlinePath) return { category: null, report: null };
  for (const category of REPORT_CATEGORIES) {
    for (const report of category.reports) {
      if (`${category.id}${report.id}` === inlinePath) {
        return { category, report };
      }
    }
  }
  return { category: null, report: null };
}

export const REPORT_CATEGORIES = [
  {
    id: 'sales',
    title: 'Sales Reports',
    description: 'Track sales performance across bills, items, stakeholders, and statutory dimensions.',
    icon: HiOutlineDocumentReport,
    accent: 'from-indigo-500 via-indigo-400 to-indigo-500',
    reports: [
      createReport({
        id: 'bill-wise',
        name: 'Bill Wise Summary',
        description: 'Summarise every sales bill generated within the selected date range.',
        filters: ['billStatus'],
        tableKey: 'billWise',
        permissionModule: 'Pharmacy Sales Report',
      }),
      createReport({
        id: 'bill-wise-ip',
        name: 'IP Sales Bill Wise',
        description: 'View IP pharmacy sales bills with patient, doctor, totals, and balance details.',
        filters: ['billStatus'],
        tableKey: 'billWise',
        permissionModule: 'Pharmacy IP Sales Report',
      }),
      createReport({
        id: 'section-wise',
        name: 'Section Wise Report',
        description: 'View sales bills filtered by schedule code (Schedule H, H1, X).',
        filters: ['dateRange'],
        tableKey: 'billWise',
        permissionModule: 'Pharmacy Section Report',
      }),
      createReport({
        id: 'item-wise',
        name: 'Item Wise Analysis',
        description: 'Understand item performance, quantities, and revenues.',
        filters: ['item'],
        tableKey: 'itemWise',
        permissionModule: 'Pharmacy Item Sales Report',
      }),
      createReport({
        id: 'ledger',
        name: 'Sales Ledger',
        description: 'Detailed item-wise sales ledger with all transaction details including tax, discount, and amounts.',
        tableKey: 'salesledger',
        permissionModule: 'Pharmacy Sales Ledger',
      }),
      createReport({
        id: 'patient-wise',
        name: 'Patient Wise Summary',
        description: 'View billing trends and value per patient.',
        filters: ['patient'],
        tableKey: 'patientWise',
        permissionModule: 'Pharmacy Patient Report',
      }),
      createReport({
        id: 'doctor-wise',
        name: 'Doctor Wise Analysis',
        description: 'Measure prescriptions and revenue generated by each doctor.',
        filters: ['doctor', 'department'],
        tableKey: 'doctorWise',
        permissionModule: 'Pharmacy Doctor Report',
      }),
      createReport({
        id: 'item-moving',
        name: 'Item Moving Report',
        description: 'View item-wise sales and return quantities with net sold quantities.',
        filters: ['dateRange'],
        tableKey: 'itemMoving',
        permissionModule: 'Pharmacy Item Moving Report',
      }),
    ],
  },
  {
    id: 'purchase',
    title: 'Purchase Reports',
    description: 'Monitor purchase inflow by supplier, item, and statutory buckets.',
    icon: FiShoppingCart,
    accent: 'from-emerald-500 via-emerald-400 to-emerald-500',
    reports: [
      createReport({
        id: 'bill-wise',
        name: 'Bill Wise Purchases',
        description: 'Summarise purchase bills and amounts.',
        tableKey: 'billWise',
        permissionModule: 'Pharmacy Purchase Report',
      }),
      createReport({
        id: 'item-wise',
        name: 'Item Wise Purchases',
        description: 'Evaluate procurement volumes and cost per item.',
        filters: ['item'],
        tableKey: 'itemWise',
        permissionModule: 'Pharmacy Purchase Item Report',
      }),
      createReport({
        id: 'ledger',
        name: 'Purchase Ledger',
        description: 'Detailed item-wise purchase ledger with all transaction details including tax, discount, and amounts.',
        tableKey: 'purchaseledger',
        permissionModule: 'Pharmacy Purchase Ledger',
      }),
      createReport({
        id: 'return-report',
        name: 'Purchase Return Report',
        description: 'View and download purchase return invoices with supplier-wise filtering.',
        tableKey: 'purchasereturnreport',
        permissionModule: 'Pharmacy Purchase Return Report',
      }),
      createReport({
        id: 'foc-items',
        name: 'FOC Items Report',
        description: 'View free-of-cost items received on purchases, grouped by item with invoice-level drill-down.',
        filters: ['dateRange'],
        tableKey: 'focItems',
        permissionModule: 'Pharmacy FOC Items Report',
      }),
    ],
  },
  {
    id: 'salesreturn',
    title: 'Sales Return Reports',
    description: 'Understand patterns and value of sales returns with detailed drill-downs.',
    icon: FiRefreshCcw,
    accent: 'from-rose-500 via-rose-400 to-rose-500',
    reports: [
      createReport({
        id: 'bill-wise',
        name: 'Bill Wise Returns',
        description: 'Track returns mapped back to sales bills.',
        tableKey: 'billWise',
        metricsKey: 'customerWise',
        permissionModule: 'Pharmacy Sales Return Report',
      }),
    ],
  },
  {
    id: 'openingstock',
    title: 'Opening Stock Reports',
    description: 'Validate opening balance uploads and adjustments.',
    icon: FiPackage,
    accent: 'from-amber-500 via-amber-400 to-amber-500',
    reports: [
      createReport({
        id: 'bill-wise',
        name: 'Opening Entry Register',
        description: 'Summary of opening stock entries by document.',
        tableKey: 'billWise',
        metricsKey: 'stockOverview',
        permissionModule: 'Pharmacy Opening Stock Report',
      }),
    ],
  },
  {
    id: 'stockadjustment',
    title: 'Stock Adjustment Reports',
    description: 'Track manual adjustments by user and document.',
    icon: FiEdit3,
    accent: 'from-purple-500 via-purple-400 to-purple-500',
    reports: [
      createReport({
        id: 'bill-wise',
        name: 'Adjustment Register',
        description: 'Document wise adjustments with justification.',
        tableKey: 'billWise',
        metricsKey: 'userWise',
        permissionModule: 'Pharmacy Stock Adjustment Report',
      }),
    ],
  },
  {
    id: 'stockconsumption',
    title: 'Consumption Reports',
    description: 'Track manual adjustments by user and document.',
    icon: FiEdit3,
    accent: 'from-cyan-500 via-cyan-400 to-cyan-500',
    reports: [
      createReport({
        id: 'bill-wise',
        name: 'Consumption Register',
        description: 'Item wise consumption with justification.',
        tableKey: 'billWise',
        metricsKey: 'consumption',
        permissionModule: 'Pharmacy Consumption Report',
      }),
    ],
  },
  {
    id: 'stock',
    title: 'Stock Reports',
    description: 'Gain visibility into current stock positions and reorder levels.',
    icon: TbReportSearch,
    accent: 'from-slate-500 via-slate-400 to-slate-500',
    reports: [
      createReport({
        id: 'reorder-level',
        name: 'Reorder Level Report',
        description: 'View items with reorder levels and their purchase history with best prices.',
        tableKey: 'stockOverview',
        metricsKey: 'stockOverview',
        permissionModule: 'Pharmacy Reorder Level Report',
      }),
      createReport({
        id: 'ledger',
        name: 'Stock Ledger',
        description: 'View stock ledger for a specific item.',
        tableKey: 'stockOverview',
        metricsKey: 'stockOverview',
        permissionModule: 'Pharmacy Stock Ledger',
      }),
      createReport({
        id: 'expiry-report',
        name: 'Expiry Report',
        description: 'View products nearing expiry / expired as of selected date.',
        tableKey: 'stockOverview',
        metricsKey: 'stockOverview',
        permissionModule: 'Pharmacy Expiry Report',
      }),
      createReport({
        id: 'dead-stock',
        name: 'Dead Stock Report',
        description: 'Identify slow-moving and never-sold inventory with aging buckets and stock value at cost.',
        tableKey: 'stockOverview',
        metricsKey: 'stockOverview',
        permissionModule: 'Pharmacy Dead Stock Report',
      }),
    ],
  },
  {
    id: 'collection',
    title: 'Collection Reports',
    description: 'Track pharmacy bill receipts and payment collections.',
    icon: HiOutlineClipboardList,
    accent: 'from-green-500 via-green-400 to-green-500',
    reports: [
      createReport({
        id: 'pharmacy-collection',
        name: 'Pharmacy Collection Report',
        description: 'View receipts and collections for pharmacy bills only.',
        tableKey: 'billWise',
        metricsKey: 'customerWise',
        permissionModule: 'Pharmacy Collection Report',
      }),
    ],
  },

];

export const findReport = (categoryId, reportId) => {
  const category = REPORT_CATEGORIES.find((cat) => cat.id === categoryId);
  if (!category) {
    return { category: null, report: null };
  }
  const report = category.reports.find((rep) => rep.id === reportId);
  return { category, report };
};

